import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.5.1_babel-plugin_8bc0bc0fbaa006ad283dc7a63626e025/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.5.1_babel-plugin_8bc0bc0fbaa006ad283dc7a63626e025/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/carousel/CustomerLogosCarousel.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextFlip"] */ "/vercel/path0/src/components/shared/content/TextFlip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/cta/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/cta/CtaSectionGrayBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/customer-reviews/CustomerReviewsSlider.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/media/AutoPlayVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/media/VideoSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/sections/ArchitecturePillars.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/sections/G2ReviewCtaButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/sections/OtelSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/sections/PipelineAnimationIframe.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/sections/ProblemCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/sections/StatsComparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/spotlight-dots/SingleSpotlightDots.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/spotlight-dots/SpotlightDots.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/tag.tsx");
